import RouteTemplate from 'ember-route-template'
import Component from '@glimmer/component'
import { service } from '@ember/service'
import RouterService from '@ember/routing/router-service'
import env from 'customer-flows/config/environment'
import DebugToolbar from 'customer-flows/components/flow-kit/debug-toolbar/index.gts'

class ApplicationTemplate extends Component {
  @service router: RouterService
  @service frameManager: FrameManager

  get showDebugToolbar() {
    return env.devtools?.enabled ?? false
  }

  <template>
    <div
      data-route={{this.router.currentRouteName}}
      data-testid='application-route'
      class='h-(--document-element-height)
        {{if this.frameManager.isInFrame "in-frame"}}
        {{if this.frameManager.isEmbed "embedded"}}'
    >
      {{outlet}}
    </div>

    {{#if this.showDebugToolbar}}
      <DebugToolbar />
    {{/if}}
  </template>
}

export default RouteTemplate(ApplicationTemplate)
